import { render } from "./SignageListDetails.vue?vue&type=template&id=c42ee004&scoped=true&ts=true"
import script from "./SignageListDetails.vue?vue&type=script&lang=ts"
export * from "./SignageListDetails.vue?vue&type=script&lang=ts"

import "./SignageListDetails.vue?vue&type=style&index=0&id=c42ee004&lang=css"
import "./SignageListDetails.vue?vue&type=style&index=1&id=c42ee004&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c42ee004"]])

export default __exports__